  
  export default function Mission() {
    return (
      <div className="mission-container mb-50">
        <div className="bg-white py-2">
          <div className="max-w-2xl px-2 lg:px-3">
            <div className="max-w-2xl lg:mx-0 lg:max-w-none">
              <h2 className="text-pretty justify-center font-semibold tracking-tight text-gray-900">Our mission</h2>
              <div className="mt-4 lg:mt-6 flex justify-center gap-y-5">
                <div className="lg:w-full lg:max-w-2xl">
                  <p className="text-gray-600">
                    We are a modern "Think Tank" and software services company committed to innovation, thought leadership,
                    and creativity. We want the best ideas to win while simultaneously benefiting our clients, our people, and the market at large. 
                    You can find the complete list of services we offer <a href="/services" className="font-semibold text-gray-600 hover:text-gray-400">here.</a>
                  </p>
                  <p className="mt-6 lg:mt-10 max-w-xl text-gray-700">
                    We are always looking to grow our team.  <a href="/community" className="font-semibold text-gray-600 hover:text-gray-400">Come work with us.</a> 
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }